/* Monocore × KwikCart drawer — v24 (theme-owned, MINIMAL RESKIN + TWO owned exceptions).
   v24 (Mat-approved mockup 2026-07-03, .claude/preview/drawer-v24): borderless
   item rows with hairline separators, 6px vanilla band before upsell, small
   discount %, 36px controls (Mat's accepted exception to the 40px floor),
   1px navy outlines, 2-line upsell titles, equal-width upsell CTAs, and
   count-adaptive upsell cards (3+ carousel / 2 → 50-50 / 1 → full width via
   JS-set .mc-up-1/.mc-up-2 classes — :has() is banned, it fails on iOS).
   Deliberately does NOT restructure GoKwik's DOM: no reparenting, no rewrites
   of app-bound text, no layout re-architecture of app containers. v14–v18
   tried all of that and raced GoKwik's own rendering on real devices.
   This file:
   (a) injects a style sheet that re-skins the app's NATIVE layout;
   (b) rewrites image srcs to request sized thumbnails;
   (c) owned exception 1: the app's header says "(1 items)" — the app label is
       hidden (inline write post-append) and our own .mc-header span is
       appended beside it;
   (d) owned exception 2: upsell Add-to-Cart (.mc-upsell-add), appended into each
       upsell card. v25 (2026-07-10): the inline size <select> is gone — a single
       ATC matching the store card button (.mccl__add-btn: 40px mobile/8px) opens the
       SHARED size bottom-sheet via window.mcszOpenData (see monocore-product-card
       .js), consistent with product cards. The tap calls stopPropagation so it
       never bubbles to GoKwik's navigate-to-PDP handlers; the sheet opens over
       the drawer via a scoped .mcsz--over-drawer z-index. Size pick → fetch
       ('/cart/add.js'), which the app's fetch-patch detects → the APP re-renders
       the drawer. The app's native .add-btn is inline-hidden ONLY after our
       control is confirmed connected — if our append ever fails, the app button
       (variant-sheet flow) remains. Never a card without an add path.
   (e) dismiss animation: the app UNMOUNTS .sidecart/.overlay instantly on
       close (no closing class). We clone the removed node, replay it with a
       slide-out/fade-out animation, pointer-events:none, and delete it 400ms
       later. Failure mode: no animation — never a stuck or tap-blocking layer.
   All idempotent; app re-renders are healed by the observer within 100ms.
   Runs from page load and waits indefinitely for the lazily-mounted
   <shadow-dom-container> (the app's own Custom Script box executes only on
   drawer open — too late for the first add-to-cart toast). */
(function () {
  'use strict';

  var CSS = [
    '@keyframes mcshine{0%{left:-45%}60%,100%{left:115%}}',
    '@keyframes mcslidein{from{transform:translateX(100%)}to{transform:translateX(0)}}',
    '@keyframes mcfadein{from{opacity:0}to{opacity:1}}',
    '@keyframes mcslideout{from{transform:translateX(0)}to{transform:translateX(100%)}}',
    '@keyframes mcfadeout{from{opacity:1}to{opacity:0}}',
    ":host{--nv:#1B2A4A;--bd:#E5E5E5;--dk:#555;--tl:#999;--st:#6B7B8D;--win:#3B6D11;--vn:#F5F0E8;--f:'MCRupee','DM Sans',system-ui,sans-serif}",
    '.sidecart{background:#fff!important;animation:mcslidein .32s cubic-bezier(.22,.61,.36,1) both!important}',
    '.overlay{animation:mcfadein .28s ease-out both!important}',
    /* dismiss clones — decorative replay of the removed node; must never eat taps */
    '.mc-dismiss,.mc-dismiss *,.mc-dismiss-ov{pointer-events:none!important}',
    '.sidecart.mc-dismiss{animation:mcslideout .3s ease-in both!important}',
    '.overlay.mc-dismiss-ov{animation:mcfadeout .28s ease-out both!important}',
    '.sidecart *,.toast,.toast *{font-family:var(--f)!important}',
    /* app sets a fixed px height on the scroll wrapper that runs 10px short
       of the footer — scrolling content clipped above the separator line.
       .top-section already spans header→footer exactly; fill it. */
    '.side-cart-content-wrapper{height:100%!important;max-height:100%!important}',
    '.side-cart-header{border-bottom:1px solid var(--bd)!important;border-radius:0!important;box-shadow:none!important}',
    '.mc-header{font-size:15px;font-weight:600;color:var(--nv);letter-spacing:.5px}',
    '.item-list-wrapper{border:none!important;background:transparent!important;box-shadow:none!important;padding:0 16px!important}',
    /* v24: borderless item rows separated by hairlines (was bordered cards) */
    '.product-tile-wrapper{border:none!important;border-radius:0!important;margin:0!important;padding:14px 0!important;box-shadow:none!important;background:#fff!important}',
    '.product-tile-wrapper+.product-tile-wrapper{border-top:1px solid var(--bd)!important}',
    '.sidecart-product-title{color:var(--nv)!important;font-weight:600!important;font-size:14px!important;line-height:1.35!important}',
    '.final-price{color:var(--nv)!important;font-weight:700!important}',
    '.compare-at-price,strike{color:var(--tl)!important}',
    '.item img{border-radius:8px!important;object-fit:cover!important;object-position:50% 22%!important}',
    /* v24: select matches the counter (1px navy, 6px radius, 36px — Mat's
       accepted exception to the 40px touch floor). appearance:none + own
       chevron: desktop browsers otherwise layer native select chrome
       (taller box, platform radius) over the reskin. */
    '.details select{height:36px!important;min-width:72px!important;box-sizing:border-box!important;font-size:14px!important;color:var(--nv)!important;border:1px solid var(--nv)!important;border-radius:6px!important;padding:0 28px 0 12px!important;appearance:none!important;-webkit-appearance:none!important;background:#fff url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6"><path d="M1 1l4 4 4-4" stroke="%231B2A4A" stroke-width="1.6" fill="none" stroke-linecap="round"/></svg>\') no-repeat right 10px center!important}',
    /* qty stepper — strict flex so −/count/+ are always vertically centred */
    /* pin the stepper to its content (30+34+30 + 2px borders): app CSS pads
       it ~20px wider, which squeezed .details and shoved the select under it;
       the stepper+trash row drives the whole right column's width at 375px */
    '.quantity-handler{height:36px!important;width:96px!important;padding:0!important;box-sizing:border-box!important;background:#fff!important;border:1px solid var(--nv)!important;border-radius:6px!important;overflow:hidden!important;display:flex!important;align-items:stretch!important;justify-content:space-between!important}',
    '.quantity-handler *{background:transparent!important;border:none!important}',
    '.quantity-handler input{color:var(--nv)!important;font-weight:600!important;font-size:14px!important;text-align:center!important;width:34px!important;min-width:34px!important;height:100%!important;padding:0!important;margin:0!important;border-left:1px solid var(--bd)!important;border-right:1px solid var(--bd)!important;align-self:stretch!important;border-radius:0!important}',
    '.reduce-quantity,.increase-quantity{color:var(--nv)!important;font-size:16px!important;min-width:30px!important;height:100%!important;margin:0!important;padding:0!important;align-self:stretch!important;display:flex!important;align-items:center!important;justify-content:center!important;line-height:1!important}',
    '.remove-btn svg{opacity:.6}',
    '.item:not(.upsell) .remove-btn{padding:12px!important;margin:-12px -6px -12px -12px!important;box-sizing:content-box!important;cursor:pointer!important}',
    '.breakdown-toggle{padding:8px!important}',
    '.item:not(.upsell) .details{display:flex!important;flex-direction:column!important;justify-content:space-between!important;flex:1 1 auto!important;min-width:0!important}',
    '.item:not(.upsell) .item-price{display:flex!important;flex-direction:column!important;align-items:flex-end!important;justify-content:space-between!important}',
    '.quantity-handler-wrapper{display:flex!important;align-items:center!important;margin:0!important;padding:0!important}',
    '.details .variant-list,.details select{margin-bottom:0!important}',
    '.item:not(.upsell) .item-price{display:grid!important;grid-template-columns:auto auto!important;grid-template-rows:auto auto 1fr!important;justify-content:end!important;column-gap:6px!important;align-items:center!important}',
    '.item:not(.upsell) .item-price :is(strike,.compare-at-price){grid-column:1/3;justify-self:end;font-size:11px!important}',
    /* v24: discount % small + brand green */
    '.item:not(.upsell) .item-price .discount-percentage{grid-row:2;grid-column:1;margin:0!important;white-space:nowrap!important;font-size:11px!important;font-weight:600!important;color:var(--win)!important}',
    '.item:not(.upsell) .item-price .final-price{grid-row:2;grid-column:2}',
    '.item:not(.upsell) .item-price .quantity-handler-wrapper{grid-column:1/3;grid-row:3;justify-self:end;align-self:end}',
    '.ribbon{display:none!important}',
    /* ---- upsell: no container border; 6px vanilla band separates it from
       the cart items (v24 #9) — ::before bleeds across the 16px padding ---- */
    '.upSell-container{background:#fff!important;border:none!important;border-radius:0!important;box-shadow:none!important;padding:0 16px 16px!important;overflow:visible!important}',
    '.upSell-container::before{content:"";display:block;height:6px;background:var(--vn);border-top:1px solid var(--bd);border-bottom:1px solid var(--bd);margin:0 -16px 14px}',
    '.upSell-container .title,.upSell-container .title p{color:var(--nv)!important;font-size:13px!important;font-weight:600!important;letter-spacing:.3px!important;text-transform:none!important;margin:0 0 12px!important}',
    '.upSell-container .card{background:#fff!important;border:1px solid var(--bd)!important;border-radius:12px!important;box-shadow:none!important;overflow:hidden!important}',
    '.upSell-container .card :is(.discount-banner,.discount-percentage){display:none!important}',
    '.upSell-container .card{display:block!important;flex:0 0 150px!important;width:150px!important}',
    '.upSell-container .card .product-title-button{display:block!important;width:100%!important;padding:0!important;border:none!important;background:none!important}',
    '.upSell-container .card .card-left-container{width:100%!important}',
    /* app CSS caps the img at max-height:85px (beats height!important) and
       gives card-right-container a 16px left margin from its old horizontal
       layout — both must be neutralized or the card renders short + off-center */
    '.upSell-container .card img{display:block!important;width:100%!important;height:185px!important;max-height:none!important;border-radius:12px 12px 0 0!important;object-fit:cover!important;object-position:50% 22%!important}',
    '.upSell-container .card .card-right-container{display:flex!important;flex-direction:column!important;align-items:flex-start!important;text-align:left!important;width:100%!important;margin:0!important;padding:10px 10px 0!important;box-sizing:border-box!important}',
    /* app CSS trap: .product-name carries max-width:5.6rem — must be lifted.
       v24: full title visible — 2-line clamp (left-aligned; iOS line-clamp is
       only flaky with centred text), min-height reserves the 2nd line so
       carousel cards stay level */
    '.upSell-container .card .product-name{display:-webkit-box!important;-webkit-line-clamp:2!important;-webkit-box-orient:vertical!important;width:100%!important;max-width:none!important;font-size:12px!important;font-weight:600!important;color:var(--nv)!important;text-align:left!important;white-space:normal!important;overflow:hidden!important;margin:0 0 2px!important;line-height:1.3!important;min-height:31px!important}',
    '.upSell-container.mc-up-1 .card .product-name,.upSell-container.mc-up-2 .card .product-name{min-height:0!important}',
    /* row-reverse puts the final price first, MRP strike after it; the <br>
       between them (app markup: strike<br>span) is dropped from the row */
    '.upSell-container .card p.price{display:flex!important;flex-direction:row-reverse!important;justify-content:flex-end!important;flex-wrap:wrap!important;align-items:baseline!important;gap:5px!important;margin:0!important;font-size:14px!important;font-weight:700!important;color:var(--nv)!important;width:100%!important}',
    '.upSell-container .card p.price br{display:none!important}',
    '.upSell-container .card strike{display:inline!important;font-size:11px!important;font-weight:400!important;color:var(--st)!important;text-decoration:line-through!important}',
    /* app's native add button — kept styled as the FALLBACK path (shows only
       if our .mc-upsell controls fail to mount; hidden via inline JS otherwise) */
    '.upSell-container .card .add-btn{display:inline-flex!important;align-items:center!important;justify-content:center!important;height:44px!important;line-height:1!important;width:auto!important;min-width:64px!important;max-width:calc(100% - 16px)!important;margin:8px auto 10px!important;padding:0 16px!important;box-sizing:border-box!important}',
    '.upSell-container .card .add-btn{color:var(--nv)!important;background:#fff!important;border:1px solid var(--nv)!important;border-radius:8px!important;font-weight:600!important}',
    /* owned upsell control — single ATC matching the store's card button
       (.mccl__add-btn: 44px tall, 8px radius, 12px/1.5px uppercase). Tapping it
       opens the shared size bottom-sheet over the drawer (see buildUpsellControls).
       box-sizing pinned border-box: width:100% + padding would overflow the
       overflow:hidden card otherwise (never rely on the app's global). */
    '.mc-upsell{width:100%;margin:8px 0 12px}',
    '.mc-upsell-add{height:40px;width:100%;box-sizing:border-box!important;background:var(--nv);color:#fff;border:none;border-radius:8px;font-size:12px;font-weight:600;letter-spacing:1.5px;text-transform:uppercase;font-family:var(--f);cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0 12px}',
    '.mc-upsell-add:disabled{opacity:.6;cursor:default}',
    /* v24 #7 — count-adaptive upsell layout (classes set by apply()) */
    '.upSell-container.mc-up-2 .card{flex:1 1 0!important;width:auto!important;min-width:0!important}',
    '.upSell-container.mc-up-1 .card{flex:1 1 100%!important;width:100%!important}',
    '.upSell-container.mc-up-1 .card img{height:230px!important}',
    '.sidecart-footer{border-top:1px solid var(--bd)!important;border-radius:0!important;box-shadow:none!important}',
    '.estimated-total{color:var(--dk)!important;font-size:13px!important;font-weight:500!important}',
    '.total-amount,.estimated-total-container{color:var(--nv)!important;font-size:16px!important}',
    '.total-amount strike,.estimated-total-container strike{font-size:12px!important}',
    '.sidecart-footer .discount-percentage{color:var(--win)!important;font-weight:600!important;font-size:11px!important}',
    '.gokwik-checkout button{position:relative!important;height:56px!important;overflow:hidden!important;border-radius:8px!important}',
    '.gokwik-checkout button::after{content:"";position:absolute;top:0;bottom:0;left:-45%;width:36%;background:rgba(255,255,255,.16);transform:skewX(-20deg);animation:mcshine 2.8s ease-in-out infinite;pointer-events:none}',
    '.btn-text p{font-size:16px!important;font-weight:700!important;letter-spacing:.5px!important;color:#fff!important}',
    '.sidecart-empty p{color:var(--dk)!important}',
    '.sidecart-empty button{border-radius:8px!important;font-weight:600!important}',
    '.toast{border-radius:8px!important;font-weight:600!important;box-shadow:0 8px 24px rgba(27,42,74,.3)!important}',
    '.toast.success::before{content:"✓";display:inline-block;margin-right:9px;font-weight:700;color:#fff}'
  ].join('\n');

  /* product title → [{id, size, available}] for the upsell size selects.
     Built once from /products.json; apply() no-ops the selector until ready. */
  var variantMap = null;
  var bootedRoot = null;
  fetch('/products.json?limit=250')
    .then(function (r) { return r.json(); })
    .then(function (d) {
      var m = {};
      (d.products || []).forEach(function (p) {
        var sizeIdx = -1;
        (p.options || []).forEach(function (o, i) {
          var nm = (o && o.name) ? o.name : o;
          if (/size/i.test(String(nm))) sizeIdx = i;
        });
        var arr = (p.variants || []).map(function (v) {
          /* size '' when the product has no Size option — lets the upsell filter
             treat "no size" as "no purchasable size" and drop the suggestion */
          var size = sizeIdx === 0 ? v.option1 : sizeIdx === 1 ? v.option2 : sizeIdx === 2 ? v.option3 : '';
          /* price in cents — the size sheet's bag footer sums it. products.json
             gives a decimal string ("999.00"); the sheet works in cents like the
             card pills' data-price. */
          var cents = Math.round(parseFloat(v.price) * 100);
          return { id: v.id, size: size, available: v.available !== false, price: isNaN(cents) ? 0 : cents };
        });
        m[p.title] = arr;
        /* Also index by image filename. GoKwik can render a STALE product name
           on an upsell card (observed live: a rename left cards showing the old
           name), but the card image stays current — so the image is the reliable
           key back to live sizes. 'img:' prefix keeps the two keyspaces apart. */
        var idxImg = function (src) {
          if (!src) return;
          var fn = String(src).split('/').pop().split('?')[0];
          if (fn) m['img:' + fn] = arr;
        };
        (p.images || []).forEach(function (im) { idxImg(im && im.src); });
        (p.variants || []).forEach(function (v) { if (v.featured_image) idxImg(v.featured_image.src); });
      });
      variantMap = m;
      if (bootedRoot) apply(bootedRoot);
    })
    .catch(function () { /* selects never mount; app's native add path remains */ });

  /* Resolve a GoKwik upsell card → our variant array. Prefer the displayed
     name; fall back to the card image filename, which survives GoKwik showing
     a stale/renamed product name. Returns null until variantMap has loaded. */
  function resolveEntry(card) {
    if (!variantMap) return null;
    var nameEl = card.querySelector('.product-name');
    if (nameEl) {
      var byName = variantMap[nameEl.textContent.trim()];
      if (byName) return byName;
    }
    var img = card.querySelector('img');
    if (img) {
      var fn = String(img.currentSrc || img.src || '').split('/').pop().split('?')[0];
      if (fn) return variantMap['img:' + fn] || null;
    }
    return null;
  }

  function buildUpsellControls(card, right, entry) {
    var box = document.createElement('div');
    box.className = 'mc-upsell';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mc-upsell-add';
    var anyAvail = entry.some(function (v) { return v.available; });
    btn.textContent = anyAvail ? 'Add' : 'Out of Stock';
    /* every size out of stock → dead button up front, not tappable-then-fails */
    if (!anyAvail) btn.disabled = true;

    /* app's fetch-patch sees a raw /cart/add.js and re-renders the drawer */
    function addVariant(vid) {
      if (!vid) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: String(vid), quantity: 1 })
      }).then(function (res) {
        if (!res.ok) throw new Error('add failed');
      }).catch(function () {
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = 'Add'; }, 1500);
      });
    }

    btn.addEventListener('click', function (e) {
      /* GoKwik wraps the whole card in a navigate-to-PDP button — without this
         the tap bubbles up to it and opens the product page ("that page"). */
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;

      var nameEl = card.querySelector('.product-name');
      var title = nameEl ? nameEl.textContent.trim() : '';
      var img = card.querySelector('img');
      var priceEl = card.querySelector('.price');
      var priceText = '', compareText = '';
      if (priceEl) {
        var strike = priceEl.querySelector('strike, s, .compare-at-price');
        if (strike) compareText = strike.textContent.trim();
        var clone = priceEl.cloneNode(true);
        Array.prototype.forEach.call(clone.querySelectorAll('strike, s, .compare-at-price'), function (n) { n.parentNode.removeChild(n); });
        priceText = clone.textContent.replace(/\s+/g, ' ').trim();
      }
      var sizes = entry.filter(function (v) { return v.size; }).map(function (v) {
        return { label: v.size, variantId: v.id, available: v.available, price: v.price };
      });

      /* Open the same bottom-sheet the product cards use. Since 2026-08-25 the
         sheet adds through Monocore.cart itself and stays open for multi-size /
         multi-qty picking; onAdd is only the no-sheet fallback below. The app's
         fetch patch still sees /cart/add.js, so the drawer re-renders as before. */
      var opened = window.mcszOpenData && window.mcszOpenData({
        thumb: img ? (img.currentSrc || img.src) : '',
        title: title,
        priceText: priceText,
        compareText: compareText,
        sizes: sizes,
        opener: btn,
        elevate: true,   /* sheet opens over the drawer — needs the raised z-index */
        onAdd: addVariant
      });

      /* no sheet on page / a size-less product → keep a working direct add */
      if (!opened) {
        var fa = entry.filter(function (v) { return v.available; })[0] || entry[0];
        if (fa) addVariant(fa.id);
      }
    });

    box.appendChild(btn);
    right.appendChild(box);
    return box;
  }

  function apply(root) {
    if (!root.querySelector('#monocore-kwik-brand')) {
      var s = document.createElement('style');
      s.id = 'monocore-kwik-brand';
      s.textContent = CSS;
      root.appendChild(s);
    }
    var hostP = root.querySelector('.side-cart-subHeader p');
    if (hostP && !hostP.closest('.mc-dismiss')) {
      var mc = hostP.querySelector('.mc-header');
      if (!mc) { mc = document.createElement('span'); mc.className = 'mc-header'; hostP.appendChild(mc); }
      var n = 0;
      root.querySelectorAll('.item-list-wrapper .item:not(.upsell)').forEach(function (it) {
        if (it.closest('.mc-dismiss')) return;
        var inp = it.querySelector('.item-quantity');
        var q = inp ? parseInt(inp.value, 10) : 1;
        n += (isNaN(q) || q < 1) ? 1 : q;
      });
      var want = 'CART (' + n + (n === 1 ? ' item)' : ' items)');
      if (mc.textContent !== want) mc.textContent = want;
      /* Hide the app's own label ONLY once our span is live in the DOM —
         inline write, no :has() dependency (v21's :has() gate silently
         failed on Mat's iPhone → both headers rendered). If the append
         ever fails, the app label stays visible; never a blank header. */
      if (mc.isConnected) {
        root.querySelectorAll('.side-cart-subHeader .header-text').forEach(function (ht) {
          if (!ht.contains(mc) && ht.style.display !== 'none') {
            ht.style.setProperty('display', 'none', 'important');
          }
        });
      }
    }
    /* v24 #7 — count-adaptive upsell layout: 3+ carousel / 2 → 50-50 / 1 →
       full width. Class writes are attribute mutations (unobserved, no loop);
       an app re-render drops them and the observer re-applies within 100ms.
       v25: also drop suggestions with no purchasable size — the count is over
       the VISIBLE cards so the layout adapts to what's left. */
    root.querySelectorAll('.upSell-container').forEach(function (upc) {
      if (upc.closest('.mc-dismiss')) return;
      var total = 0, visible = 0;
      upc.querySelectorAll('.card').forEach(function (card) {
        total++;
        var entry = resolveEntry(card);
        /* Hide a suggestion with no purchasable size — every size out of stock,
           or no Size option at all. GoKwik picks the products; we suppress the
           dead ones. Act ONLY on products resolved in our data — a product we
           can't judge stays exactly as GoKwik rendered it. */
        var hide = entry ? !entry.some(function (v) { return v.size && v.available; }) : false;
        /* !important — the app's own `.upSell-container .card{display:block!important}`
           would otherwise beat a plain inline display:none. */
        if (hide) card.style.setProperty('display', 'none', 'important');
        else card.style.removeProperty('display');
        if (!hide) visible++;
      });
      upc.classList.toggle('mc-up-1', visible === 1);
      upc.classList.toggle('mc-up-2', visible === 2);
      /* all suggestions dropped → hide the section so there's no orphan
         "You may also like" header. Only once variantMap has loaded. */
      if (variantMap && total > 0 && visible === 0) upc.style.setProperty('display', 'none', 'important');
      else upc.style.removeProperty('display');
    });
    /* owned ATC per VISIBLE upsell card (exception 2 — see header) */
    if (variantMap) {
      root.querySelectorAll('.upSell-container .card').forEach(function (card) {
        if (card.closest('.mc-dismiss')) return;
        if (card.style.display === 'none') return; /* dropped: no purchasable size */
        var right = card.querySelector('.card-right-container');
        if (!right) return;
        var entry = resolveEntry(card);
        if (!entry || !entry.length) return;
        var box = card.querySelector('.mc-upsell');
        if (!box) box = buildUpsellControls(card, right, entry);
        /* hide the app's add button ONLY while our controls are live */
        if (box && box.isConnected) {
          var appBtn = card.querySelector('.add-btn');
          if (appBtn && appBtn.style.display !== 'none') {
            appBtn.style.setProperty('display', 'none', 'important');
          }
        }
      });
    }
    root.querySelectorAll('.item img, .upSell-container .card img').forEach(function (img) {
      if (/cdn\.shopify\.com|\/cdn\/shop\//.test(img.src) && !/[?&]width=/.test(img.src)) {
        img.src = img.src + (img.src.indexOf('?') > -1 ? '&' : '?') + 'width=300';
      }
    });
  }

  /* dismiss animation (exception e): replay the unmounted node as an inert clone */
  function dismissFx(root, node, cls) {
    if (root.querySelector('.sidecart:not(.mc-dismiss)')) return; /* already reopened */
    if (root.querySelector('.' + cls)) return;
    var c = node.cloneNode(true);
    c.classList.add(cls);
    c.setAttribute('aria-hidden', 'true');
    root.appendChild(c);
    setTimeout(function () { if (c.parentNode) c.parentNode.removeChild(c); }, 400);
  }

  var booted = false;
  function boot() {
    if (booted) return true;
    var host = document.querySelector('shadow-dom-container');
    if (!host || !host.shadowRoot) return false;
    booted = true;
    var root = host.shadowRoot;
    bootedRoot = root;
    apply(root);
    var pending = false;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var rem = muts[i].removedNodes;
        for (var j = 0; j < rem.length; j++) {
          var nd = rem[j];
          if (nd.nodeType !== 1 || !nd.classList) continue;
          if (nd.classList.contains('mc-dismiss') || nd.classList.contains('mc-dismiss-ov')) continue;
          if (nd.classList.contains('sidecart')) dismissFx(root, nd, 'mc-dismiss');
          else if (nd.classList.contains('overlay')) dismissFx(root, nd, 'mc-dismiss-ov');
        }
      }
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; apply(root); }, 100);
    }).observe(root, { childList: true, subtree: true });
    return true;
  }

  if (!boot()) {
    var mo = new MutationObserver(function () { if (boot()) mo.disconnect(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
/* deploy: v25 upsell→size-sheet (2026-07-10 re-push to bump asset hash) */
